"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleXmark,
  faCirclePlus,
} from "@fortawesome/sharp-light-svg-icons";
import React, { useState } from "react";

const More: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="flex flex-col">
      <div className={`${showAll ? "" : "h-[100px]"} overflow-hidden relative homepage-text-sm`}>
        <div
          className={`${showAll ? "hidden" : "absolute inset-0 bg-gradient-to-b from-white/0 via-white/0 to-white/100"}`}
        ></div>
        {children}
      </div>
      <div>
        <button
          onClick={() => setShowAll(!showAll)}
          className="border-b flex w-full py-4 gap-1 items-center homepage-text-sm"
        >
          {showAll ? (
            <FontAwesomeIcon className="size-3" icon={faCircleXmark} />
          ) : (
            <FontAwesomeIcon className="size-3" icon={faCirclePlus} />
          )}
          {showAll ? "Mindre" : "Mere"}
        </button>
      </div>
    </div>
  );
};

export default More;
